import { useEffect, useState } from "react";
import CustomSnackbar from "src/components/UI/Alerts/customSnackbar";
import { Layout } from "src/components/Layout";
import { Input } from "src/components/UI/Forms/Inputs";
import Modal from "src/components/UI/Modal";
import { MemberList } from "src/components/Members/memberList";
import { useForm } from "react-hook-form";
import {
  Email,
  FullName,
  UaePhone,
  SelectAnyValue,
} from "src/utils/validations/formValidations";
import {
  useGetUsersQuery,
  useInviteUserMutation,
  usePatchUserMutation,
  useSearchUserByEmailQuery,
} from "src/services/user/user";
import { User } from "src/utils/interfaces/interfaces";
import CustomSelect from "src/components/UI/Forms/Inputs/customSelect";
import PhoneInput from "src/components/UI/Forms/Inputs/phoneInput";
import { Button, Pagination } from "@heroui/react";
import { useTranslation } from "react-i18next";
import { useDebounce } from "src/utils/algorithms";
import { FaPlus } from "src/icons";

export interface IMembersProps { }
export function Members(props: IMembersProps) {
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm();
  const {
    register: registerEditForm,
    handleSubmit: handleEditForm,
    setValue: setValueEditForm,
    formState: { errors: editErrors },
  } = useForm();
  const [showAddMember, setShowAddMember] = useState(false);
  const [editMemberData, setEditMemberData] = useState<User>();
  const [showEditMember, setShowEditMember] = useState(false);
  const [blockMemberData, setBlockMemberData] = useState<User>();
  const [showBlockMember, setShowBlockMember] = useState(false);
  const [addGuestError, setAddGuestError] = useState(false);
  const [editGuestError, setEditGuestError] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState<"success" | "error" | "info" | "warning">("success");
  const [currentPage, setCurrentPage] = useState(1);
  const [searchedInput, setSearchedInput] = useState("");
  const debouncedSearchTerm = useDebounce(searchedInput, 600);
  const { data: Users, isLoading, refetch: refetchUser } = useGetUsersQuery({ page: currentPage, limit: 10 });
  const { data: SearchedList } = useSearchUserByEmailQuery(debouncedSearchTerm, { skip: !debouncedSearchTerm });
  const [inviteUser, resultInvite] = useInviteUserMutation();
  const [patchUser, resultPatch] = usePatchUserMutation();
  const searchedUsers = SearchedList?.response ?? [];
  const hasSearch = searchedInput.trim().length > 0;

  const onChangeSearch = (searchString: any) => {
    setSearchedInput(searchString);
  };

  const onChangeSort = (key: any) => { };

  const onAddMember = async (data: any) => {
    setAddGuestError(false);
    const _payload = { ...data, phone: data.phone ? `+971${data.phone.replace(/^(?:\+?971)/, '')}` : "" };
    inviteUser(_payload)
      .unwrap()
      .then((response) => {
        setShowAddMember(false);
        refetchUser();
        reset();
        setSnackbarMessage("Member created successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
      })
      .catch((error) => {
        if (error?.originalStatus === 201 || error?.originalStatus === 200) {
          setShowAddMember(false);
          refetchUser();
          reset();
          setSnackbarMessage("Member created successfully!");
          setSnackbarSeverity("success");
          setOpenSnackbar(true);
        } else {
          setAddGuestError(true);
          const errorMsg = error?.data?.message || 'Failed to create member';
          setSnackbarMessage(typeof errorMsg === 'string' ? errorMsg : 'Failed to create member');
          setSnackbarSeverity("error");
          setOpenSnackbar(true);
        }
      });
  };



  const onEditMember = (data: any) => {
    setEditGuestError(false);
    const _payload = { ...data, phone: data.phone ? `+971${data.phone.replace(/^(?:\+?971)/, '')}` : "" };
    patchUser({ id: editMemberData?._id, data: _payload })
      .unwrap()
      .then((response) => {
        if (response) {
          setShowEditMember(false);
          refetchUser();
          reset();
        } else setEditGuestError(true);
      })
      .catch((error) => {
        setEditGuestError(true);
        reset();
      });
  };



  const handlePageClick = (page: number) => {
    setCurrentPage(page);
    refetchUser();
  };

  let usersListCount = Users?.meta.count || 0;
  let totalUsersPages = Math.ceil(usersListCount / 10);

  const { t } = useTranslation();

  return (
    <>
      <div className="w-full h-screen px-6 py-4 pb-40 overflow-y-auto overflow-x-hidden" style={{ backgroundColor: "var(--bg-base)", color: "var(--text-main)" }}>
        <div className="sticky top-0 z-20 py-6 pb-4" style={{ backgroundColor: "var(--bg-base)" }}>
          <div className="flex items-center justify-between">
            <h3 className="text-2xl ms-4">
              {t("members_page.title")} <bdi>({Users ? Users.meta.count : "0"})</bdi>
            </h3>
            <div className="flex justify-end gap-4">
              <Button
                variant="solid"
                size="sm"
                className="rounded-md shadow-lg m-1 p-5 font-semibold text-sm transition-colors duration-200"
                style={{
                  backgroundColor: "var(--color-primary)",
                  color: "var(--text-invert)",
                }}
                onPress={() => setShowAddMember(true)}
                startContent={<FaPlus />}
                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "var(--color-primary-hover)")}
                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "var(--color-primary)")}
              >
                {t("members_page.add_member_btn")}
              </Button>
              <Input
                type="text"
                placeholder={t("members_page.search_textbox")}
                inputClassName="bg-[var(--bg-surface)] shadow-sm rounded-lg border border-[var(--border-light)] text-[var(--text-main)] placeholder:text-[var(--text-muted)] h-[45px]"
                onChange={(e: any) => onChangeSearch(e.target.value)}
                iconUrl="/assets/icons/search.svg"
              ></Input>
            </div>
          </div>
        </div>
        <section className="flex-grow overflow-visible">
          <div
            className="rounded-2xl overflow-hidden mb-2 border shadow-sm"
            style={{
              backgroundColor: "var(--bg-surface)",
              borderColor: "var(--border-light)",
            }}
          >
            {!isLoading &&
              (hasSearch ? (
                searchedUsers.length > 0 ? (
                  searchedUsers
                    .map((user: User, index: number) => (
                      <MemberList
                        key={user._id}
                        user={user}
                        isLastItem={index === searchedUsers.length - 1}
                        onBlockAction={() => {
                          setBlockMemberData(user);
                          setShowBlockMember(true);
                        }}
                        onEditAction={(organisation: string) => {
                          reset();
                          setEditMemberData({ ...user, organisation: organisation });
                          setShowEditMember(true);
                        }}
                        onRemoveAction={() => { }}
                      />
                    ))
                ) : (
                  <p className="p-10" style={{ color: "var(--text-muted)" }}>No result found.</p>
                )
              ) : (
                Users.response
                  ?.map((user: User, index: number) => (
                    <MemberList
                      key={user._id}
                      user={user}
                      isLastItem={index === Users.response.length - 1}
                      onBlockAction={() => {
                        setBlockMemberData(user);
                        setShowBlockMember(true);
                      }}
                      onEditAction={(organisation: string) => {
                        reset();
                        setEditMemberData({ ...user, organisation: organisation });
                        setShowEditMember(true);
                      }}
                      onRemoveAction={() => { }}
                    />
                  ))
              ))}
          </div>
        </section>
        {!searchedInput && !isLoading && (
          <div className="fixed bottom-0 left-0 right-0 z-10 flex justify-center border-t py-4" style={{ backgroundColor: "var(--bg-base)", borderColor: "var(--border-light)" }}>
            <Pagination
              radius={"full"}
              color={"success"}
              size={"md"}
              showShadow
              showControls={true}
              total={totalUsersPages}
              initialPage={1}
              page={currentPage}
              onChange={handlePageClick}
              classNames={{
                next: "rtl:rotate-180 border border-[var(--border-light)] bg-[var(--bg-surface)] text-[var(--text-main)]",
                prev: "rtl:rotate-180 border border-[var(--border-light)] bg-[var(--bg-surface)] text-[var(--text-main)]",
                item: "border border-[var(--border-light)] bg-[var(--bg-surface)] text-[var(--text-main)]",
                cursor: "bg-[var(--color-primary)] text-[var(--text-invert)] shadow-[var(--shadow-card)]",
              }}
            />
          </div>
        )}
      </div>
      <Modal
        show={showBlockMember}
        align="center"
        onClose={() => setShowBlockMember(false)}
        className="rounded-lg mx-auto w-[25%] top-10 start-1/2 transform -translate-x-1/2"
      >
        <div className="px-6 py-5 mx-auto text-center rounded-2xl shadow-card bg-[var(--bg-surface)] text-[var(--text-main)]">
          <img
            src="/assets/icons/vendors/avatar.svg"
            alt="avatar"
            className="inline mb-4"
          />
          <h3 className="text-white">Block Angel Bergson</h3>
          <p className="text-sm mx-auto opacity-70" style={{ color: "var(--text-muted)" }}>
            {t("vendors_page.block.block_message")}
          </p>
          <div className="grid grid-cols-2 gap-4 mt-8">
            <button
              className="p-3 rounded-lg border transition-colors duration-200" style={{ border: "1px solid var(--border-light)", color: "var(--text-main)" }}
              onClick={() => setShowBlockMember(false)}
            >
              {t("vendors_page.block.cancel")}
            </button>
            <button
              className="p-3 rounded-lg font-semibold transition-colors duration-200" style={{ backgroundColor: "var(--color-primary)", color: "var(--text-invert)" }}
              onClick={() => setShowBlockMember(false)}
            >
              {t("vendors_page.block.block_user")}
            </button>
          </div>
        </div>
      </Modal>
      <Modal
        show={showAddMember}
        onClose={() => setShowAddMember(false)}
        align="right"
        className="w-1/3 shadow-card bg-[var(--bg-surface)] text-[var(--text-main)]"
      >
        <div className="h-screen">
          <div className="p-8 pb-0 ">
            <img
              onClick={() => setShowAddMember(false)}
              src="/assets/icons/cross.svg"
              alt="close"
              className="ltr:float-right rtl:float-left cursor-pointer"
            ></img>
            <h3 className="mb-10 text-2xl" style={{ color: "var(--text-main)" }}>
              {t("members_page.add_member_btn")}
            </h3>
            <form className="h-[80vh] overflow-y-scroll pe-5">
              <Input
                type="text"
                name="firstName"
                label={t("members_page.edit.first_name")}
                placeholder="Jon"
                className="!mb-9"
                inputClassName="shadow-sm border border-[var(--border-light)] text-[var(--text-main)] placeholder:text-[var(--text-muted)]"
                register={register}
                validation={FullName}
                error={errors.email}
                errorText="Enter a valid First Name"
              />
              <Input
                type="text"
                name="lastName"
                label={t("members_page.edit.last_name")}
                placeholder="Doe"
                className="!mb-9"
                inputClassName="shadow-sm border border-[var(--border-light)] text-[var(--text-main)] placeholder:text-[var(--text-muted)]"
                register={register}
                validation={FullName}
                error={errors.lastName}
                errorText="Enter a valid Last Name"
              />
              <CustomSelect
                name="type"
                id="type"
                options={[
                  { code: "enforcement", name: "Enforcement" },
                  { code: "vendor", name: "Vendor" },
                ]}
                label={t("members_page.edit.user_type")}
                placeholder={t("members_page.edit.select_user_type")}
                register={register}
                setValue={setValue}
                validation={SelectAnyValue}
                className="!mb-9 "
                labelClassName="text-xs !text-white/[0.8] mb-1"
                selectClassName="shadow-sm border border-[var(--border-light)] text-[var(--text-main)] placeholder:text-[var(--text-muted)] w-full"
                error={errors.type}
                errorText="Select a type"
              />
              <Input
                type="email"
                name="email"
                label={t("members_page.edit.email")}
                placeholder="Enter your email"
                className="!mb-9"
                inputClassName="shadow-sm border border-[var(--border-light)] text-[var(--text-main)] placeholder:text-[var(--text-muted)]"
                register={register}
                validation={Email}
                error={errors.email}
                errorText="Enter a valid Email Address"
              />
              <PhoneInput
                type="tel"
                name="phone"
                label={t("members_page.edit.phone_number")}
                placeholder="55XXXXXXX"
                disableCountryCode={true}
                className="!mb-16"
                inputClassName="shadow-sm border border-[var(--border-light)] text-[var(--text-main)] placeholder:text-[var(--text-muted)]"
                prefixClassName="shadow-sm border border-[var(--border-light)] text-[var(--text-main)] placeholder:text-[var(--text-muted)] w-full"
                register={register}
                validation={UaePhone}
                error={errors.phone}
                errorText="Enter a valid 9-digit Mobile Number"
              />
            </form>
          </div>
          <div className="absolute bottom-0 z-50 w-full px-8 pt-3 pb-8 shadow-md" style={{ backgroundColor: "var(--bg-surface)", borderTop: "1px solid var(--border-light)" }}>
            <button
              className="w-full p-3 rounded-lg font-semibold transition-colors duration-200" style={{ backgroundColor: "var(--color-primary)", color: "var(--text-invert)" }}
              onClick={handleSubmit((d) => onAddMember(d))}
            >
              {t("members_page.add_member_btn")}
            </button>
            {addGuestError && (
              <p className="mt-1 text-xs text-center text-[var(--color-error)]">
                Failed to add guest.
              </p>
            )}
          </div>
        </div>
      </Modal>
      <Modal
        show={showEditMember}
        onClose={() => setShowEditMember(false)}
        align="right"
        className="w-1/3 shadow-card bg-[var(--bg-surface)] text-[var(--text-main)]"
      >
        <div className="h-screen">
          <div className="p-8 pb-0 ">
            <img
              onClick={() => setShowEditMember(false)}
              src="/assets/icons/cross.svg"
              alt="close"
              className="ltr:float-right rtl:float-left cursor-pointer"
            ></img>
            <h3 className="mb-10 text-2xl" style={{ color: "var(--text-main)" }}>
              {t("members_page.add_member_btn")}
            </h3>
            <form className="h-[80vh] overflow-y-scroll pe-5">
              <Input
                type="text"
                name="firstName"
                label={t("members_page.edit.first_name")}
                placeholder="Jon"
                defaultValue={editMemberData?.firstName}
                className="!mb-9"
                inputClassName="shadow-sm border border-[var(--border-light)] text-[var(--text-main)] placeholder:text-[var(--text-muted)]"
                register={registerEditForm}
                validation={FullName}
                error={editErrors.email}
                errorText="Enter a valid First Name"
              />
              <Input
                type="text"
                name="lastName"
                label={t("members_page.edit.last_name")}
                placeholder="Doe"
                defaultValue={editMemberData?.lastName}
                className="!mb-9"
                inputClassName="shadow-sm border border-[var(--border-light)] text-[var(--text-main)] placeholder:text-[var(--text-muted)]"
                register={registerEditForm}
                validation={FullName}
                error={editErrors.lastName}
                errorText="Enter a valid Last Name"
              />
              <CustomSelect
                name="type"
                id="type"
                options={[
                  { code: "enforcement", name: "Enforcement" },
                  { code: "vendor", name: "Vendor" },
                ]}
                label={t("members_page.edit.user_type")}
                placeholder={t("members_page.edit.select_user_type")}
                defaultValue={editMemberData?.type}
                register={registerEditForm}
                setValue={setValueEditForm}
                validation={SelectAnyValue}
                className="!mb-9"
                labelClassName="text-xs !text-white/[0.8] mb-1"
                selectClassName="shadow-sm border border-[var(--border-light)] text-[var(--text-main)] placeholder:text-[var(--text-muted)] w-full"
                error={editErrors.type}
                errorText="Select a type"
              />
              <Input
                type="email"
                name="email"
                label={t("members_page.edit.email")}
                placeholder="Enter your email"
                defaultValue={editMemberData?.email}
                className="!mb-9"
                inputClassName="shadow-sm border border-[var(--border-light)] text-[var(--text-main)] placeholder:text-[var(--text-muted)]"
                register={registerEditForm}
                validation={Email}
                error={editErrors.email}
                errorText="Enter a valid Email Address"
              />
              <PhoneInput
                type="tel"
                name="phone"
                label={t("members_page.edit.phone_number")}
                placeholder="1234567890"
                defaultValue={editMemberData?.phone?.replace(/^(?:\+?971)/, '')}
                disableCountryCode={true}
                className="!mb-16"
                inputClassName="shadow-sm border border-[var(--border-light)] text-[var(--text-main)] placeholder:text-[var(--text-muted)]"
                prefixClassName="shadow-sm border border-[var(--border-light)] text-[var(--text-main)] placeholder:text-[var(--text-muted)] w-full"
                register={registerEditForm}
                validation={UaePhone}
                error={editErrors.phone}
                errorText="Enter a valid 9-digit Mobile Number"
              />
            </form>
          </div>
          <div className="absolute bottom-0 w-full px-8 pt-3 pb-8 shadow-md" style={{ backgroundColor: "var(--bg-surface)", borderTop: "1px solid var(--border-light)" }}>
            <button
              className="w-full p-3 rounded-lg font-semibold transition-colors duration-200" style={{ backgroundColor: "var(--color-primary)", color: "var(--text-invert)" }}
              onClick={handleEditForm((d) => onEditMember(d))}
            >
              {t("members_page.edit.save_changes")}
            </button>
            {editGuestError && (
              <p className="mt-1 text-xs text-center text-[var(--color-error)]">
                {t("members_page.edit.failed_to_save")}
              </p>
            )}
          </div>
        </div>
      </Modal>
      <CustomSnackbar
        open={openSnackbar}
        handleClose={() => setOpenSnackbar(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
        duration={4000}
      />
    </>
  );
}
